export default __webpack_public_path__ + "static/media/article.f50bbb85.jpg";